import React from 'react';
import { useLocation } from 'react-router';
import { TokenExpired } from '../Presentation';
import { pages } from '@/settings/pages';

export const TokenExpiredContainer: React.FC = () => {
  const location = useLocation();
  const flow = location.state?.flow as string | undefined;
  const from = location.state?.from as string | undefined;

  const intervalKey =
    flow === 'passwordReset' ? 'password.reset' : 'activation';
  const linkTo =
    from === 'passwordReset'
      ? pages.password.reset.start
      : pages.activation.start;

  return (
    <TokenExpired
      intervalKey={intervalKey}
      linkTo={linkTo}
      errorCode={location.state.errorCode}
    />
  );
};
